<script setup>
// AutoShell — picks the chrome by audience for routes BOTH audiences can reach
// (today: /topics and its focused player).
//
// A signed-in learner gets the application shell (sidebar, workspace nav). An
// anonymous visitor gets the storefront shell — otherwise clicking "Practise" on
// the new public page would drop them into a sidebar app, and the illusion
// breaks at exactly the moment it matters most.
//
// Each shell renders its own <router-view />, so the child route is unaffected.
import ConsumerShell from "./ConsumerShell.vue";
import PublicLayout from "./public/PublicLayout.vue";
import { useAuthStore } from "@digitalstreams/saas-core/vue/stores/authStore";

const auth = useAuthStore();
</script>

<template>
  <ConsumerShell v-if="auth.isLoggedIn" />
  <PublicLayout v-else />
</template>
